import { createSelector } from 'reselect';

import { AppState } from '../../reducers/root.reducer';

const timer = (state: AppState) => state.survey.questionnaire.timer;

const getCurrentId = createSelector(timer, (timer) => timer.currentId);
const getCurrentTime = createSelector(timer, (timer) => timer.time);

export const SurveyTimerSelectors = {
    getCurrentId,
    getCurrentTime,
};
